<!-- 个人中心 > 企业信息 -->
<template>
  <div class="enterpriseInfo">
    <commonHeader :title="'企业信息'"></commonHeader>
    <span class="myEdit" @click="noticeEdit">
      <img style="vertical-align: top;margin-right: 10px" src="../../../assets/img/personalCenter/edit.png" alt="">
      编辑
    </span>
    <div class="enterpriseInfoMain">
      <el-form ref="enterpriseInfoForm" label-position="left" style="margin: 30px 10px 0">
        <el-form-item label="企业logo :" label-width="160px">
          <img :src="companyInfo.logoImg ? $winpowUrl + companyInfo.logoImg : defaultAvatar" style="width: 80px;height: 80px;" alt="">
        </el-form-item>
        <template v-for="item in formList">
          <el-form-item :key="item.field" :label="item.label + ' : '" label-width="160px">
            <span class="detail">{{ companyInfo[item.field] }}</span> <template v-if="item.field === 'redistCapital'"> 万元</template>
          </el-form-item>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script>
import commonHeader from '../componets/CommonHeader'
import { mapState } from 'vuex'
export default {
  name: 'Enterprise',
  components: { commonHeader },
  props: {
    companyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      enterpriseInfo: '',
      isEdit: false,
      defaultAvatar: require('../../../assets/img/personalCenter/enterpriseLogo.png'),
      formList: [
        {
          field: 'companyName',
          label: '企业名称'
        },
        {
          field: 'socialCreditCode',
          label: '信用代码'
        },
        {
          field: 'foundTime',
          label: '注册时间'
        },
        {
          field: 'redistCapital',
          label: '注册资本'
        },
        {
          field: 'registAddress',
          label: '注册地址'
        },
        {
          field: 'companyProfile',
          label: '公司简介'
        }
      ]
    }
  },
  computed: {
    ...mapState(['userData'])
  },
  created() {
    this.getCompanyInfo()
  },
  methods: {
    getCompanyInfo() {
      this.$post('/front/userCenter/companyInfo', {}).then(res => {
        if (res) {
          this.enterpriseInfo = res
        }
      })
    },
    noticeEdit() {
      this.$confirm('需前往盈创动力修改企业信息', '提示', {
        confirmButtonText: '跳转',
        cancelButtonText: '取消'
      }).then(() => {
        window.open(this.$winpowUrl)
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.enterpriseInfo {
  position: relative;
  .myEdit {
    color: #1474DE;
    position: absolute;
    top: 7px;
    left: 150px;
    cursor: pointer
  }
  .myEdit:hover {
    color: #1466CF !important;
  }
  .enterpriseInfoMain {
    width: 100%;
    border-top: 2px solid #EAEAEA;
    margin-top: 20px;
    .detail {
      font-size: 16px;
    }
  }
  .myButtons {
    display: inline-block;
    margin-left: 280px;
    margin-top: 30px;
    .myBtn {
      width: 70px;
      margin: 0 20px;
      height: 30px;
      border-radius: 4px;
      font-size: 16px
    }
  }
}
</style>
